import { render, staticRenderFns } from "./Playlists.vue?vue&type=template&id=08a8ecbb&scoped=true&"
import script from "./Playlists.vue?vue&type=script&lang=js&"
export * from "./Playlists.vue?vue&type=script&lang=js&"
import style0 from "./Playlists.vue?vue&type=style&index=0&id=08a8ecbb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a8ecbb",
  null
  
)

export default component.exports